import * as XLSX from 'xlsx';

const exportExcel = (selectedPageData) => {
  if (!selectedPageData) return;

  const posts = selectedPageData.PostFBs || [];

  const byDay = new Map();
  const byWeek = new Map();
  const byMonth = new Map();

  const addInteraction = (map, timeKey, userName, user365Name, type) => {
    if (!userName) return;

    const key = `${timeKey}__${userName}`;
    const current = map.get(key) || {
      Thời_gian: timeKey,
      User: userName,
      'User365': user365Name || '-',
      'Số Reaction': 0,
      'Số Comment': 0,
      Tổng: 0,
    };

    if (type === 'reaction') current['Số Reaction'] += 1;
    if (type === 'comment') current['Số Comment'] += 1;
    current['Tổng'] = current['Số Reaction'] + current['Số Comment'];

    map.set(key, current);
  };

  // Process all interactions from posts
  posts.forEach(post => {
    // Process reactions
    post.ReactionFBs?.forEach(reaction => {
      const reactionDate = new Date(reaction.created_time || reaction.createdAt || post.created_time);
      
      // Format for day: DD/MM/YYYY
      const day = reactionDate.toLocaleDateString('vi-VN');
      
      // Format for week: YYYY-Www (ISO week format)
      const getWeekNumber = (d) => {
        const date = new Date(d.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        const week1 = new Date(date.getFullYear(), 0, 4);
        return Math.round(((date - week1) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7) + 1;
      };
      const weekNum = getWeekNumber(reactionDate);
      const week = `${reactionDate.getFullYear()}-W${weekNum.toString().padStart(2, '0')}`;
      
      // Format for month: MM/YYYY
      const month = `${(reactionDate.getMonth() + 1).toString().padStart(2, '0')}/${reactionDate.getFullYear()}`;

      const name = reaction.user?.name || reaction.name;
      const User365Name = reaction.user?.User365Name || '';
      
      addInteraction(byDay, day, name, User365Name, 'reaction');
      addInteraction(byWeek, week, name, User365Name, 'reaction');
      addInteraction(byMonth, month, name, User365Name, 'reaction');
    });

    // Process comments
    post.CommentFBs?.forEach(comment => {
      const commentDate = new Date(comment.created_time || comment.createdAt || post.created_time);
      
      // Format for day: DD/MM/YYYY
      const day = commentDate.toLocaleDateString('vi-VN');
      
      // Format for week: YYYY-Www (ISO week format)
      const getWeekNumber = (d) => {
        const date = new Date(d.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        const week1 = new Date(date.getFullYear(), 0, 4);
        return Math.round(((date - week1) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7) + 1;
      };
      const weekNum = getWeekNumber(commentDate);
      const week = `${commentDate.getFullYear()}-W${weekNum.toString().padStart(2, '0')}`;
      
      // Format for month: MM/YYYY
      const month = `${(commentDate.getMonth() + 1).toString().padStart(2, '0')}/${commentDate.getFullYear()}`;

      const name = comment.user?.name || comment.name;
      const User365Name = comment.user?.User365Name || '';
      
      addInteraction(byDay, day, name, User365Name, 'comment');
      addInteraction(byWeek, week, name, User365Name, 'comment');
      addInteraction(byMonth, month, name, User365Name, 'comment');
    });
  });

  const wb = XLSX.utils.book_new();

  const convertMapToSheet = (map) => {
    const arr = Array.from(map.values());
    arr.sort((a, b) => b['Tổng'] - a['Tổng']); // Sort by total interactions descending
    return XLSX.utils.json_to_sheet(arr);
  };

  XLSX.utils.book_append_sheet(wb, convertMapToSheet(byDay), 'Ngày');
  XLSX.utils.book_append_sheet(wb, convertMapToSheet(byWeek), 'Tuần');
  XLSX.utils.book_append_sheet(wb, convertMapToSheet(byMonth), 'Tháng');

  const fileName = `${selectedPageData.name || 'FanPage'}_BaoCao.xlsx`;
  XLSX.writeFile(wb, fileName);
};

export default exportExcel;